var _style, _polygon, _polygon2, _rect, _polygon3, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLectraDefCmjnBlackRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 408.4 161.3",
    style: {
      enableBackground: "new 0 0 408.4 161.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#BE1622;}\r\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "62.1,100.2 62.1,54 54.4,54 54.4,100.2 54.4,107.9 62.1,107.9 92.8,107.9 92.8,100.2 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "115.9,84.8 131.2,84.8 131.2,77.1 108.2,77.1 108.2,84.8 108.2,100.2 108.2,107.9 115.9,107.9 146.6,107.9  146.6,100.2 115.9,100.2 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 108.2,
    y: 54,
    className: "st0",
    width: 38.4,
    height: 7.7
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "344.8,107.9 354,107.9 334.9,54 325.7,54 337.8,88.1 314.8,88.1 314.8,88.5 307.9,107.9 317.1,107.9 321.4,96  340.6,96 "
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 223.4,
    y: 69.5,
    width: 7.7,
    height: 38.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.8,93.4c-3.5,4.1-8.8,6.8-14.6,6.8c-10.6,0-19.2-8.6-19.2-19.2c0-10.6,8.6-19.2,19.2-19.2c6.2,0,11.6,2.9,15.1,7.4 l6-4.8C197.4,58,189.7,54,181.2,54c-14.9,0-26.9,12.1-26.9,26.9s12,26.9,26.9,26.9c8.4,0,15.8-3.8,20.8-9.8L195.8,93.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M288.6,86.2c5.3-2.9,9-8.6,9-15c0-9.4-7.6-17.1-17-17.2l0.1,0l-72.6,0l0,7.6l58.2,0c0,0,0,0,0,0l14.3,0 c5.3,0,9.6,4.3,9.6,9.6c0,5.2-4.1,9.5-9.3,9.7h-10.4V69.4l-8.6,0v20.8h0v17.6h8.6V90.2h0v-2.1h7.6c0.4,0.1,0.8,0.1,1.2,0.1 l10.6,19.5h10.3L288.6,86.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLectraDefCmjnBlackRed);
export default __webpack_public_path__ + "static/media/Logo_Lectra_def_CMJN_black-red.364d5db7a135cc68a45542670922e383.svg";
export { ForwardRef as ReactComponent };